export const sharedEnvironment = {

	/** Program name */
	appName: 'Iovent Device',
	/** Program version */
	appVersion: '9.3.0-rc.4',

	/** Settings for the WebAPI interface */
	webApi: {
		/** Long polling time in ms */
		statusMaxResponseTimeMs: 4000,
		/** Timeout for HTTP requests; must be greater than long polling time */
		httpTimeoutMs: 5000,
		/** After a timeout, try to reach the server again after this amount of ms */
		retryAfterTimeoutMs: 2000
	}
};
